import * as React from "react";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialAction from "@mui/material/SpeedDialAction";

import ShareIcon from "@mui/icons-material/Share";
import LinkIcon from "@mui/icons-material/Link";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import XIcon from '@mui/icons-material/X';

export default function ShareFloatButton() {
  const [open, setOpen] = React.useState(false);

  const actions = [
    { icon: <LinkIcon style={{ color: "darkmagenta" }} />, name: "Copiar link", onClick: () => navigator.clipboard.writeText(window.location.href) },
    { icon: <XIcon style={{ color: "black" }} />, name: "Twitter/X", onClick: () => window.open("https://x.com/", "_blank") },
    { icon: <FacebookIcon style={{ color: "blue" }} />, name: "Facebook", onClick: () => window.open("https://facebook.com/", "_blank") },
    { icon: <LinkedInIcon style={{ color: "#62BFEF" }} />, name: "LinkedIn", onClick: () => window.open("https://linkedin.com/", "_blank") },
    { icon: <WhatsAppIcon style={{ color: "green" }} />, name: "WhatsApp", onClick: () => window.open("https://wa.me/?text=" + encodeURIComponent(window.location.href)) },
  ];

  return (
    <SpeedDial
      ariaLabel="Menu de compartilhamento"
      sx={{
        position: "fixed",
        bottom: 16,
        right: 16,
      }}
      icon={<ShareIcon />}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
    >
      {actions.map((action) => (
        <SpeedDialAction
          key={action.name}
          icon={action.icon}
          tooltipTitle={action.name}
          onClick={action.onClick}
        />
      ))}
    </SpeedDial>
  );
}
